import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  container: HTMLElement | (() => HTMLElement);
  children: React.ReactNode;
  open?: boolean;
}

const Portal: React.FC<Props> = ({ container, children, open = false }) => {

  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);
  
  useEffect(() => {
    if (open) {
      const containerElement = (typeof container === 'function') ? container() : container;
      const newPortalElement = document.createElement('div');
      containerElement?.appendChild(newPortalElement);
      setPortalElement(newPortalElement);
      // clean up function
      return () => {
        containerElement?.removeChild(newPortalElement);
        setPortalElement(null);
      };
    }
  }, [container, open]);

  if (portalElement) {
    return createPortal(children, portalElement);
  }

  return null;
};
export default Portal;
